save<template>
    <v-container v-if="this.config.hasBuckets" class="assignment-view-wrapper">
        <bucket-filters @search="onSearch" @export="onExport" :title="'Εμφυσήσεις'"/>
        <div class="number-of-results-wrapper">
            <div class="number-of-results"><h4 class="mr-1">Σύνολο Αποτελεσμάτων:</h4> {{ this.totalElements }}</div>
        </div>
        <div v-if="!loading">
            <v-container v-if="assignmentViewPreference === 'cards'" class="card-container">
                <v-card
                    v-for="(assignment, index) of assignments"
                    :key="assignment.id"
                    class="assignment-card"
                    :class="{ 'slide-right': index < 10 }"
                    :style="{ animationDelay: `${index * 0.1}s` }"
                    elevation="10"
                    max-width="100%"
                    link
                    @click="assignmentClick(assignment.id)"
                >
                    <v-card-title class = "card-title" @click.stop="">
                        <div class="sr-type-wrapper">
                            <div class="sr-title">{{assignment.sr}}</div>
                            <div class="assignment-type">({{ getTypeText(assignment.type) }})
                                <info-assignment-button :extraInfo="assignment.extraInfo" />
                            </div>
                        </div>
                        <div>
                            <v-chip
                                v-if="assignment.priority"
                                class="mr-2 white--text"
                                :color="priorities[assignment.priority]"
                                small
                            >
                                <b>{{ assignment.priority }}</b>
                            </v-chip>
                            <v-chip
                                v-if="assignment.pilotImportType && assignment.type === 'PILOT'"
                                class="mr-2 white--text"
                                :color="assignment.pilotImportType === 'FROM_CONSTRUCTION' ? '#95b8d1' : '#b19cd9'"
                                small
                            >
                                {{ getAssignmentImportTypeText(assignment) }}
                            </v-chip>
                            <v-chip
                                v-if="assignment.type === 'LAST_DROP' && assignment.lastDropWholebuy"
                                class="mr-2 white--text"
                                color="#95b8d1"
                                small
                            >
                                Wholebuy
                            </v-chip>
                            <assignment-status-label :status="assignment.status" />
                        </div>
                    </v-card-title>
                    <v-card-subtitle>
                        <assignment-stepper :assignment="assignment" class="assignment-stepper" @onStepperClick="assignmentClick(assignment.id)"/>
                    </v-card-subtitle>
                    <v-card-subtitle>
                        <div class="card-subtitle-wrapper">
                            <div class="card-building-wrapper mx-2">
                                <v-icon v-if="assignment.extraInfo?.coordinates" large class="google-maps-icon" @click.stop="openMapOnCoordinates(assignment.extraInfo.coordinates)">mdi-google-maps</v-icon>
                                <v-icon medium class="bulding-id-icon">mdi-domain</v-icon> {{ assignment.buildingId }}
                                <div class="building-info-wrapper">
                                    <div v-if="assignment.clientFloor">Όροφος: {{ assignment.clientFloor }}</div>
                                    <div v-if="assignment.noOfFloors">Σύνολο Ορόφων: {{ assignment.noOfFloors }}</div>
                                    <div>Διεύθυνση: {{ assignment.address }}</div>
                                    <div>Περιοχή: {{ assignment.location?.name }}</div>
                                </div>
                            </div>
                            <div class="card-client-wrapper mx-2">
                                <v-icon medium class="client-icon">mdi-account</v-icon>Πελάτης
                                <div class="client-info-wrapper">
                                    <span>{{ assignment.clientName }}</span>
                                </div>
                            </div>
                            <div class="card-client-wrapper mx-2">
                                <v-icon medium class="client-icon" color="#ffc000">mdi-account-group</v-icon> Ατόμα σε ανάθεση
                                <div class="assignees-info-wrapper">
                                    <div>{{ assignment.noOfPeople }}</div>
                                </div>
                            </div>
                            <div class="card-date-wrapper mx-2">
                                <v-icon medium class="date-icon" >mdi-clock-fast</v-icon>
                                <span v-if="assignment.contractor" class="contractor-assignment">Ανάθεση σε
                                    <div v-if="assignment.contractor">
                                        <h4>{{ assignment.contractor.name }}</h4>
                                    </div>
                                </span>
                                <span v-else>Δεν έχει ανατεθεί σε εργολάβο</span>
                                <div v-if="assignment.assignedToContractorAt" class="date-info-wrapper">
                                    <div>{{ getDate(assignment.assignedToContractorAt) }}</div>
                                </div>
                            </div>
                            <div v-if="assignment.autopsy?.nextStepsAt" class="card-date-wrapper mx-2">
                                <v-icon medium class="date-icon" >mdi-clock-fast</v-icon>
                                <span class="contractor-assignment">Έγκριση Κατασκευής</span>
                                <div class="date-info-wrapper">
                                    <div>{{ getDate(assignment.autopsy.nextStepsAt) }}</div>
                                </div>
                            </div>
                            <div v-if="assignment.constructionDate" class="card-date-wrapper mx-2">
                                <v-icon medium class="date-icon" >mdi-clock-fast</v-icon>
                                <span class="contractor-assignment">Ημ/νία Κατασκευής</span>
                                <div class="date-info-wrapper">
                                    <div>{{ getDate(assignment.constructionDate) }}</div>
                                </div>
                            </div>
                        </div>
                    </v-card-subtitle>
                    <v-card-subtitle class="card-footer my-1">
                        <div class="mx-2">
                            <div class="card-date">
                                <v-icon medium class="date-icon" >mdi-sun-clock</v-icon>
                                <div v-if="!assignment.age && assignment.assignedToContractorAt" class="d-flex ">Ημέρες από ανάθεση: <h4 class="ml-1">{{ daysSinceAssignmentCreated(assignment.assignedToContractorAt) }}</h4></div>
                                <div v-else-if="assignment.age" class="d-flex age-info"> Age: <h4 class="ml-1">{{ assignment.age }}</h4> </div>
                            </div>
                        </div>
                        <div class="created-at">
                            Δημιουργήθηκε {{ getDate(assignment.createdAt) }}
                            <span v-if="assignment.contractorFrom?.name"> από <v-chip dark small>{{ assignment.contractorFrom?.name }}</v-chip></span>
                        </div>
                    </v-card-subtitle>
                    <div style="height: 65px; width: 100%;"></div>
                    <div class="take-me-row" :class="{'has-appointment': !!assignment.blowingTaskInfo, 'is-touched': touchedAssignmentId === assignment.id}" @click.stop="takeOver(assignment)" @touchstart.stop="handleTakeMeRowTouch(assignment, $event)">
                        <div class="take-me-main"><span v-if="assignment.blowingTaskInfo && assignment.blowingTaskInfo.isCurrentUserAssignee">ΑΛΛΑΞΕ ΤΟ ΡΑΝΤΕΒΟΥ ΣΟΥ</span><span v-else>ΑΝΕΛΑΒΕ ΤΗΝ ΕΜΦΥΣΗΣΗ</span></div>
                        <div class="take-me-extra">
                            <div v-if="!assignment.blowingTaskInfo">Χωρίς Ραντεβού για Εμφύσηση</div>
                            <div v-else-if="assignment.blowingTaskInfo">
                                <div v-if="assignment.blowingTaskInfo.appointmentDate" class="d-flex"><v-icon medium color="#ffffff" class="mr-1">mdi-calendar-clock</v-icon>Ραντεβού στις: {{ assignment.blowingTaskInfo.appointmentDate }}</div>
                                <div v-if="assignment.blowingTaskInfo.assignee" class="d-flex"><v-icon medium color="rgb(255, 192, 0)" class="mr-1">mdi-account</v-icon>Ανατεθειμένος: {{ assignment.blowingTaskInfo.assignee }}</div>
                                <div class="d-flex"><v-icon medium color="rgb(0, 150, 136)" class="mr-1">mdi-list-status</v-icon>Status Εμφύσησης: {{ assignment.blowingTaskInfo.status ? getBlowingStatusText(assignment.blowingTaskInfo.status) : '-' }}</div>
                            </div>
                        </div>
                    </div>
                </v-card>
                <v-pagination
                    v-if="totalPages"
                    class="pagination"
                    v-model="page"
                    :length="totalPages"
                    total-visible="7"
                    color="black"
                    circle
                    @input="paginationChange"
                />
                <div class="pagination-selections">
                    <v-select
                        v-model="size"
                        class="size"
                        :hint="`Αντικείμενα / σελίδα: ${this.size}`"
                        :items="sizes"
                        persistent-hint
                        return-object
                        single-line
                        @input="sizeChange"
                    />
                    <v-autocomplete
                        v-model="page"
                        class="page"
                        :hint="`Μεταφορά στη σελίδα`"
                        :items="Array(totalPages).fill().map((v,i)=> i + 1)"
                        persistent-hint
                        return-object
                        single-line
                        @input="paginationChange"
                    />
                </div>
            </v-container>
            <array-view
                v-else
                class="assignment-table"
                :items="assignments"
                :headers="headers"
                :totalPages="totalPages"
                :page="page"
                :size="size"
                :config="config"
                @paginationChange="tablePaginationChange"
                @item-clicked="(e) => assignmentClick(e.id)"
                @onTakeBlowing="(e) => takeOver(e)"
            />
        </div>
        <div v-else class="loading-overlay">
            <div class="loader" /><span class="loading-text">Οι Αναθέσεις φορτώνουν...</span>
        </div>
        <v-dialog v-if="selectedAssignmentForBlowing" v-model="showCalendarDialog" max-width="500px">
            <v-card>
                <v-card-title class="card-title">Ημερομηνία και Ώρα Ραντεβού Εμφύσησης</v-card-title>
                <v-card-subtitle>για την Ανάθεση με SR: {{ selectedAssignmentForBlowing.sr }}</v-card-subtitle>
                <v-date-picker
                    v-if="!appointmentDate"
                    v-model="appointmentDate"
                    color="#0047AB"
                    class="datepicker"
                    :min="getGreekDate(new Date())"
                    locale="el"
                ></v-date-picker>
                <v-time-picker
                    v-else-if="appointmentDate && !appointmentTime"
                    v-model="appointmentTime"
                    color="#0047AB"
                    format="24hr"
                    class="datepicker"
                    scrollable
                    :disabled="!appointmentDate"
                ></v-time-picker>
                <v-text-field
                    v-else-if="appointmentDate && appointmentTime"
                    v-model="greekDatetime"
                    class="field mx-4"
                    label="Στις"
                    prepend-icon="mdi-calendar"
                    clearable
                    readonly
                    @click:clear="() => {
                        appointmentDate = null
                        appointmentTime = null
                    }"
                ></v-text-field>
                <v-card-actions v-if="!successTakeOver" class="d-flex justify-center">
                    <v-btn
                        color="black white--text"
                        :disabled="!appointmentDate || !appointmentTime"
                        @click="submitTakeOver"
                    >ΥΠΟΒΟΛΗ</v-btn>
                    <v-btn
                        color="red white--text"
                        @click="cancelTakeOver"
                    >ΑΚΥΡΩΣΗ</v-btn>
                </v-card-actions>
                <v-fade-transition>
                    <div v-if="successTakeOver" class="minimal-success-wrapper">
                        <v-icon color="success" size="24" class="mr-2">mdi-check-circle-outline</v-icon>
                        <span class="success-text">Η Ανάληψη της Εμφύσησης ήταν επιτυχής! <br> Ραντεβού: <strong>{{ greekDatetime }}</strong></span>
                    </div>
                </v-fade-transition>
                <alert :show-alert="showAlert" :message="message" :type="type" />
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import ArrayView from '@/components/ArrayView.vue'
    import assignmentService from '@/services/assignment'
    import momentTimezone from 'moment-timezone'
    import AssignmentStepper from '@/components/AssignmentStepper.vue'
    import AssignmentStatusLabel from '@/components/AssignmentStatusLabel.vue'
    import client from '@/services/client'
    import BucketFilters from '@/components/BucketFilters'
    import jwtUtil from '@/utils/jwtUtil'
    import location from '@/services/location'
    import fileUtil from '@/utils/file'
    import InfoAssignmentButton from '@/components/InfoAssignmentButton'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { BucketFilters, AssignmentStatusLabel, ArrayView, AssignmentStepper, InfoAssignmentButton, Alert },
        computed: {
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            isMyAssignmentsEnabled() {
                return this.$store.getters.getMyAssignmentsEnabled
            },
            assignmentViewPreference() {
                return this.$store.getters.getAssignmentViewPreference
            },
            currentUserId() {
                return Number(this.$store.getters.getUserId)
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            defaultPageSize() {
                return this.config?.defaultPageSize || 5
            },
            blowingStatuses() {
                return [...this.config?.blowing?.statuses] || []
            },
            types() {
                return this.config?.assignmentTypes || []
            },
            pilotAssignmentImportTypes() {
                return this.config.pilotImportTypes || []
            },
            getSavedPosition() {
                let savedPosition = sessionStorage.getItem('assignment-saved-position')
                if (savedPosition) {
                    savedPosition = JSON.parse(savedPosition || null)
                }
                return savedPosition
            },
            getPageFromRouteQueryOrSavedPosition() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.page && !isNaN(routeQuery.page)) {
                    return parseInt(routeQuery.page)
                }
                const savedPosition = this.getSavedPosition
                if (savedPosition) {
                    return savedPosition.page
                }
                return 1
            },
            getSizeFromRouteQueryOrSavedPosition() {
                const routeQuery = this.$route.query
                if (routeQuery && routeQuery.size && !isNaN(routeQuery.size)) {
                    return parseInt(routeQuery.size)
                }
                const savedPosition = this.getSavedPosition
                if (savedPosition) {
                    return savedPosition.size
                }
                return this.defaultPageSize
            },
            dateTime() {
                return (this.appointmentDate ? this.appointmentDate : '') + (this.appointmentTime ? ' ' + this.appointmentTime : '')
            },
            greekDatetime() {
                return this.dateTime ? this.getGreekDateTime(this.dateTime) : ''
            }
        },
        watch: {
            '$route.query': {
                handler(newQuery, oldQuery) {
                    if (newQuery !== oldQuery) {
                        this.getPageAndSizeFromRoute()
                    }
                },
                deep: true
            }
        },
        data: () => {
            return {
                appointmentDate: null,
                appointmentTime: null,
                selectedAssignmentForBlowing: null,
                assignments: [],
                clients: [],
                sizes: [5, 10, 30, 60, 100],
                page: 1,
                size: 5,
                totalPages: 0,
                totalElements: 0,
                panel: undefined,
                query: {},
                sort: null,
                selectedClient: null,
                contractors: [],
                checkBox: false,
                showAlert: false,
                showCalendarDialog: false,
                touchedAssignmentId: null,
                message: null,
                type: null,
                headers: [
                    {
                        text: 'Ανέλαβε την Εμφύσηση',
                        align: 'center',
                        sortable: false,
                        value: 'blowingTaskInfo'
                    },
                    {
                        text: 'SR',
                        align: 'start',
                        sortable: false,
                        value: 'sr'
                    },
                    { text: 'Ημ/νία Εμφύσησης', align: 'center', value: 'blowingTaskInfo.appointmentDate' },
                    { text: 'Εμφύσηση από', align: 'center', value: 'blowingTaskInfo.assignee' },
                    { text: 'Ημ/νία Κατασκευής', align: 'center', value: 'constructionDate' },
                    { text: 'Priority', align: 'center', value: 'priority' },
                    { text: 'Status', align: 'center', value: 'status' },
                    { text: 'Age', value: 'age' },
                    { text: 'Τύπος', value: 'type' },
                    { text: 'Όνομα Πελάτη', align: 'center', value: 'clientName' },
                    { text: 'BuildingId', align: 'center', value: 'buildingId' },
                    { text: 'Διεύθυνση', align: 'center', value: 'address' },
                    { text: 'Περιοχή', align: 'center', value: 'location.name' },
                    { text: 'Α/Κ', align: 'center', value: 'ak' },
                    { text: 'Ανατέθηκε στις', align: 'center', value: 'assignedToContractorAt' },
                    { text: 'Ανατέθηκε σε', align: 'center', value: 'contractor.name' },
                    { text: 'Συμμετέχοντες', align: 'center', value: 'noOfPeople' }
                ],
                priorities: {
                    'A+': '#8b0000',
                    'A': '#ff0000',
                    'B': '#2596be',
                    'C': '#00b050'
                },
                loading: false,
                successTakeOver: false
            }
        },
        async created() {
            this.getPageAndSizeFromRoute()
            this.getAllClients()
        },
        methods: {
            getGreekDateTime(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('DD-MM-YYYY HH:mm').toString()
            },
            getGreekDate(utcDateTime) {
                return momentTimezone(utcDateTime).utc().tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            handleTakeMeRowTouch(assignment, event) {
                if (this.touchedAssignmentId === assignment.id) {
                    // Second touch on the same row — let the click event fire
                    this.touchedAssignmentId = null
                } else {
                    // First touch — expand the row, suppress the click
                    event.preventDefault()
                    this.touchedAssignmentId = assignment.id
                }
            },
            takeOver(assignment) {
                this.selectedAssignmentForBlowing = assignment
                this.showCalendarDialog = true
            },
            cancelTakeOver() {
                this.showCalendarDialog = false
                setTimeout(() => {
                    if (!this.showCalendarDialog) {
                        this.selectedAssignmentForBlowing = null
                        this.appointmentDate = null
                        this.appointmentTime = null
                        this.successTakeOver = false
                    }
                }, 300)
            },
            async submitTakeOver() {
                try {
                    this.successTakeOver = false
                    const appointmentDateTime = momentTimezone(this.dateTime).tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()
                    await assignmentService.createNewAppointmentFromBucket(this.selectedAssignmentForBlowing.id, 'BLOWING', { content: appointmentDateTime })
                    this.successTakeOver = true
                    this.fetchAllAssignments()
                    setTimeout(() => {
                        this.cancelTakeOver()
                    }, 3000)
                } catch (e) {
                    this.setAlert('Προέκυψε κάποιο σφάλμα. Επικοινωνήστε με τον διαχειριστή.', 'error')
                }
            },
            getBlowingStatusText(status) {
                return this.blowingStatuses.find(s => s.value === status).name
            },
            getAssignmentImportTypeText(assignment) {
                if (assignment.type !== 'PILOT' || !assignment.pilotImportType) {
                    return null
                }
                return this.pilotAssignmentImportTypes.find(type => type.value === assignment.pilotImportType).name
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            getAllClients() {
                client.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.selectedClient = this.clients[0]
                        this.onClientSelect(this.selectedClient.id)
                    }
                })
            },
            getPageAndSizeFromRoute() {
                this.page = this.getPageFromRouteQueryOrSavedPosition
                this.size = this.getSizeFromRouteQueryOrSavedPosition
                if (parseInt(this.$route.query.page) !== this.page || parseInt(this.$route.query.size) !== this.size) {
                    this.$router.push({ query: { page: this.page, size: this.size } })
                }
                this.fetchAllAssignments()
            },
            openMapOnCoordinates(coordinates) {
                window.open(`https://www.google.com/maps?q=${coordinates.x},${coordinates.y}`, '_blank')
            },
            getAllLocations() {
                location.getAll().then(resp => {
                    this.locations = resp.data
                })
            },
            assigneeCount(assignment) {
                return new Set(assignment.taskAssignments.map(taskAssignment => taskAssignment.assignee.id)).size
            },
            getTypeText(typeValue) {
                return this.types.find(type => type.value === typeValue).name
            },
            daysSinceAssignmentCreated(startDate, endDate) {
                if (endDate) {
                    return momentTimezone(momentTimezone(endDate)).diff(startDate, 'days')
                }
                return momentTimezone(momentTimezone()).diff(startDate, 'days')
            },
            assignmentClick(id) {
                sessionStorage.setItem('bucket-assignment-saved-position', JSON.stringify({ page: this.page, size: this.size, scrollY: window.scrollY }))
                this.$router.push(`/assignments/${id}/edit?from=blowing-bucket`)
            },
            onClientSelect(clientId) {
                const selectedClient = this.clients.find(client => client.id === clientId)
                if (selectedClient) {
                    this.contractors = [...selectedClient.contractors.filter(contractor => contractor.assignee === true)]
                }
            },
            sizeChange(size) {
                if (this.getSizeFromRouteQueryOrSavedPosition !== this.size) {
                    this.$router.push({ query: { page: this.page, size } })
                }
                sessionStorage.setItem('bucket-assignment-saved-position', JSON.stringify({ page: this.page, size: this.size }))
            },
            paginationChange(page) {
                if (this.getPageFromRouteQueryOrSavedPosition !== this.page) {
                    this.$router.push({ query: { page, size: this.size } })
                }
                sessionStorage.setItem('bucket-assignment-saved-position', JSON.stringify({ page: this.page, size: this.size }))
            },
            tablePaginationChange(page, size) {
                if (page !== this.page || size !== this.size) {
                    this.$router.push({ query: { page, size } })
                }
                this.page = page
                this.size = size
            },
            async fetchAllAssignments() {
                this.loading = true
                this.query = JSON.parse(sessionStorage.getItem('blowing-bucket-filters')) || {}
                this.sort = JSON.parse(sessionStorage.getItem('blowing-bucket-sort')) || ['age', 'DESC']
                delete this.query.taskAssignments
                this.assignments = []
                let savedPosition = sessionStorage.getItem('bucket-assignment-saved-position')
                if (savedPosition) {
                    savedPosition = JSON.parse(savedPosition || null)
                }
                this.page = savedPosition ? savedPosition.page : this.page
                this.size = savedPosition ? savedPosition.size : this.size
                assignmentService.getAssignmentsForBucket('blowing', this.page, this.size, this.query, this.sort).then(resp => {
                    this.assignments = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.totalElements = resp.data.totalElements
                }).finally(() => {
                    this.loading = false
                    if (savedPosition) {
                        this.$nextTick(() => {
                            window.scrollTo(0, savedPosition.scrollY)
                            sessionStorage.removeItem('bucket-assignment-saved-position')
                        })
                    }
                })
            },
            exportAllAssignments(query, sort) {
                delete query.taskAssignments
                assignmentService.exportAssignments(query, sort).then(resp => { fileUtil.createExport('assignments', resp.data) })
            },
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').format('DD/MM/YYYY').toString()
            },
            onSearch(filters, sort) {
                sessionStorage.setItem('blowing-bucket-filters', JSON.stringify(filters))
                sessionStorage.setItem('blowing-bucket-sort', JSON.stringify(sort))
                this.fetchAllAssignments()
            },
            onExport(filters, sort) {
                const query = { ...filters }
                if (this.query.assignedToContractorAtGte && this.query.assignedToContractorAtLte) {
                    this.query.assignedToContractorAtGte = momentTimezone(this.query.assignedToContractorAtGte).tz('Europe/Athens').startOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                    this.query.assignedToContractorAtLte = momentTimezone(this.query.assignedToContractorAtLte).tz('Europe/Athens').startOf('day').utc().add(1, 'days').format('YYYY-MM-DD[T]HH:mm:ss[Z]')
                }
                this.exportAllAssignments(query, sort)
            }
        }
    }
</script>

<style scoped>
.sr-title {
    letter-spacing: 0.5px;
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.15);
}

.loading-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1rem;
    width: 100%;
    height: 20vh;
}
.loader {
    margin-right: 0.5rem;
    min-width: 3rem;
    min-height: 3rem;
    transform: translateZ(0);
    box-sizing: border-box;
    width: 3rem;
    height: 3rem;
    border: 0.5em solid rgba(255, 255, 255, 0.3);
    border-top: 0.5rem solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}
.loading-text {
    color: var(--cards-and-tables-text-color) !important;
}
@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.card-footer {
    display: flex;
    flex-direction: column;
}
.v-input--selection-controls {
    margin-top: 0 !important;
}
.filter-test {
    display: flex;
    justify-content: center;
}
.assignment-view-wrapper {
    max-width: 90% !important;
}
.v-card__subtitle {
    padding: 0;
}
.card-date {
    display: flex;
    justify-content: center;
    width: 100%
}
.page, .size {
    max-width: 150px;
    margin-right: 1rem;
}
.pagination-selections {
    display: flex;
    width: 90%;
    justify-content: flex-end;
}
.create-new {
    display: flex;
    justify-content: end;
}
.card-title {
    display: flex;
    justify-content: space-between;
    background: var(--cards-and-tables-color) !important;
    font-weight: 500;
    font-size: 1.25rem;
    margin-bottom: 1rem;
}

.card-title-2 {
    font-weight: 500;
    font-size: 1.25rem;
}

.v-expansion-panel {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.v-card {
    min-width: 250px;
    position: relative;
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.contractor-assignment {
    text-align: center;
}

.minimal-success-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: rgba(76, 175, 80, 0.1);
    border-radius: 8px;
    margin: 1rem;
    border: 1px solid rgba(76, 175, 80, 0.2);
}

.success-text {
    font-size: 0.95rem;
    color: #2e7d32;
}
.assignment-card {
    width: 90%;
    margin-bottom: 0.8rem;
    transition: transform 0.25s ease-in-out, box-shadow 0.25s ease-in-out;
    overflow: hidden;
}
.assignment-card:hover {
    cursor: pointer;
    transform: scale(1.01);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2) !important;
    z-index: 2;
}

.take-me-row {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 65px;
    background-color: rgb(0, 71, 171, 0.6); /* lightblue with slight transparency */
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 1.1rem;
    color: white;
    transition: all 0.5s ease-in-out; /* 1 second duration, no delay */
    z-index: 10;
    cursor: pointer;
    backdrop-filter: blur(2px); /* nice glass effect for transparency */
    clip-path: polygon(0 0, 50% 0, 100% 0, 100% 100%, 0 100%);
    flex-direction: column;
}

.take-me-row:hover,
.take-me-row.is-touched {
    height: 65%; /* Covers over 60% */
    background-color: rgba(0, 71, 171, 0.95); /* Slightly more opaque on hover */
    clip-path: polygon(0 40px, 50% 0, 100% 40px, 100% 100%, 0 100%);
    font-size: 1.25rem;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.take-me-row.has-appointment:hover,
.take-me-row.has-appointment.is-touched {
    background-color: rgb(225, 193, 110, 0.95);
}

.take-me-row.has-appointment {
    background-color: rgb(225, 193, 110, 0.7);
}

.take-me-extra {
    opacity: 0;
    max-height: 0;
    font-size: 0.9rem;
    font-weight: 500;
    margin-top: 0;
    transition: all 0.4s ease-in-out;
}

.take-me-row:hover .take-me-extra,
.take-me-row.is-touched .take-me-extra {
    opacity: 1;
    max-height: 50px;
    margin-top: 10px;
    transition-delay: 0.3s;
}

.assignment-table {
    max-width: 95% !important;
}

.bulding-id-icon {
    color: #0000A3;
}

.google-maps-icon {
    color: rgb(138, 0, 0);
}

.google-maps-icon:hover {
    color: red;
}

.client-icon {
    color: #009688;
}

.building-info-wrapper {
    display: flex;
    flex-direction: column;
    padding-left: 0.3rem;
}
.card-date-wrapper {
    padding-top: 1rem;
}

.number-of-results-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 0 auto;
    width: 87%;
    align-items: center;
    margin-top: 0.5rem;
}

.age-info {
    color: var(--cards-and-tables-text-color) !important;
}
.number-of-results {
    display: flex;
    color: var(--cards-and-tables-text-color) !important;
}

.date-info-wrapper {
    font-size: 0.95rem;
    text-align: center;
    font-weight: 600;
}

.card-subtitle-wrapper {
    padding: 1rem;
    padding-top: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    color: var(--cards-and-tables-text-color);
}
.created-at {
    text-align: center;
}
.minimal-success-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    background: rgba(76, 175, 80, 0.1);
    border-radius: 8px;
    margin: 1rem;
    border: 1px solid rgba(76, 175, 80, 0.2);
}

.success-text {
    font-size: 0.95rem;
    color: #2e7d32;
}

.datepicker {
    width: 100%;
}

.card-building-wrapper {
    max-width: 340px;
    padding-top: 1rem;
}

.card-client-wrapper {
    text-align: center;
    padding-top: 1rem;
}

.date-icon {
    color: gray;
}

.client-info-wrapper {
    font-weight: 600;
    font-size: 1rem;
    max-width: 200px;
}

.assignees-info-wrapper {
    font-weight: 600;
    font-size: 1rem;
}

.card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100% !important;
}

.assignment-stepper {
    width: 90%;
    margin: 0 auto;
}

.sr-type-wrapper {
    display: flex;
    flex-wrap: wrap;
}

.assignment-type {
    display: flex;
    font-size: 1rem;
    margin-left: 0.5rem;
}

@media only screen and (max-width: 1000px) {
    .assignment-stepper {
        width: 100%;
        margin: 0 auto;
    }
}

@media only screen and (max-width: 700px) {
    .assignment-view-wrapper {
        max-width: 100% !important;
    }
    .assignment-card {
        width: 100%;
    }
    .expansion-panel {
        max-width: 100%;
    }
}

@media only screen and (max-width: 400px) {
    .card-subtitle-wrapper {
        flex-direction: column;
        align-items: center;
    }
}

@media only screen and (min-width: 600px) {
    .slide-right {
        position: relative;
        animation: slide-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    }
    @keyframes slide-right {
    0% {
        opacity: 0;
        left: 100px;
    }
    100% {
        opacity: 1;
        left: 0px;
    }
    }
}

</style>
